<div class="screen-blocker-floating-tip" id="screenBlocker-floating-tip"></div>

<div class="floating-tip" *ngIf="visible">
    <app-global-stepper [steps]="steps" [initialIndex]="initialIndex" [buttonLabel]="buttonLabel" [linkLabel]="linkLabel" (close)="hide()" (primary)="primary.emit($event)" (stepChange)="stepChange.emit($event)" (linkBack)="linkBack.emit()">
    </app-global-stepper>
</div>